import { useApp } from "@/context/AppContext";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Products } from "@/components/Products";
import { Ecosystem } from "@/components/Ecosystem";
import { Contact } from "@/components/Contact";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";

const GRAIN =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.55'/%3E%3C/svg%3E\")";

export default function Site() {
  const { content } = useApp();

  if (!content) {
    return (
      <div className="min-h-screen bg-[#14281E] flex flex-col items-center justify-center gap-4" data-testid="site-loader">
        <img src="/logo-mark.png" alt="Yutaka Agro" className="w-20 h-auto animate-pulse" />
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#FAF7F2]/60">Yutaka Agro</p>
      </div>
    );
  }

  return (
    <div className="bg-[#FAF7F2]" data-testid="site-root">
      <div
        className="pointer-events-none fixed inset-0 z-[60] opacity-[0.05] mix-blend-multiply"
        style={{ backgroundImage: GRAIN }}
      />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Products />
        <Ecosystem />
        <Contact />
      </main>
      <WhatsAppFloat />
    </div>
  );
}
